<shared-generalstatus-container *ngIf="route" [generalStatus]="route.generalStatus" (dragover)="dragover($event)"
    (drop)="dropAtZone($event)">
    <shared-trucking-route-header [route]="route"></shared-trucking-route-header>
</shared-generalstatus-container>